<template>
    <section>
            <loading v-if="!submittal"></loading>
            <form action="" @submit="save" @submit.prevent v-else>
                <fieldset>
                    <label class="required">
                        Submittal Name
                        <input type="text" placeholder="Name the submittal" required v-model="submittal.name">
                    </label>
                    <div class="actions"  v-if="!showFirstField">
                        <button @click.prevent="toggleFirstField" class="simple"><i class="fa fa-plus"></i> Add Note</button>
                    </div>
                </fieldset>

                <fieldset v-if="showFirstField">
                    <label>
                        Note
                        <textarea name="first-note" v-model="submittal.notes1"></textarea>
                        <span class="actions"></span>
                    </label>
                    <div class="actions" v-if="!showSecondField" >
                        <button @click.prevent="toggleSecondField"  class="simple">
                            <i class="fa fa-plus"></i>
                            Add Additional Note
                        </button>
                    </div>
                </fieldset>

                <fieldset v-if="showSecondField">
                    <label>
                        Note
                        <textarea name="second-note" v-model="submittal.notes2"></textarea>
                        <span class="actions"></span>
                    </label>
                </fieldset>

                <div class="confirm">
                    <div>
                        <a href="/submittal-manager" class="button back simple alternate">Projects</a>
                    </div>
                    <div>
                        <save-button :saving="saving"></save-button>
                        <button type="submit" @click="next">Next</button>
                    </div>
                </div>
            </form>
    </section>
</template>
<script>
    import information from 'vue/submittal-manager/mechanical/information/index';
    import axios from 'axios';
    import {mapActions, mapGetters} from 'vuex';

    export default {
        data() {
            return {
                showFirstField: false,
                showSecondField: false,
                nextPage: false,
                saving: false,
                csrfToken: null
            };
        },
        methods: {
            save() {

                if (!this.nextPage) {
                    this.saving = true;
                }

                let payload = this.submittal;

                payload.csrfToken = this.csrfToken;

                this
                .editSubmittalInfo(payload)
                .then(response => {
                    this.saving = false;
                    if (this.nextPage) {
                        this.$router.push({'name': 'mechanical-browse', 'submittalID': response.data.id});
                    }
                })
                .catch(response => {
                    this.saving = false;
                    //console.log(response);
                });
            },
            next() {
                this.nextPage = true;
            },
            toggleFirstField() {
                this.showFirstField = true;
            },

            toggleSecondField() {
                this.showSecondField = true;
            },

            ...mapActions('mechanical', [
                'getSubmittalInfo',
                'editSubmittalInfo',
            ]),
        },
        computed: {

            ...mapGetters('mechanical', [
                'submittal'
            ])
        },
        created() {
            this
            .getSubmittalInfo(this.submittalID)
            .then(() => {

                if (this.submittal.notes1.length > 0) {
                    this.showFirstField = true;
                }

                if (this.submittal.notes2.length > 0) {
                    this.showFirstField = true;
                    this.showSecondField = true;
                }
            });
        },
        props: ['submittalID'],
    };
</script>
